module.exports = __webpack_public_path__ + "static/media/2.26d5f8d7.jpg";